<template>
  <div>
    <HeaderHutReward />
    <nav-category mode="main"></nav-category>

    <div class="slot__wrapper">
      <slot></slot>
    </div>

    <cart></cart>
  </div>
</template>
<style lang='scss'>
  @import '../assets/css/category.css';

  .slot {
    @media screen and (min-width: 500px) and (max-width: 800px) {
      &__wrapper {
        margin-bottom: 15%;
      }
    }
  }
</style>
<script>
import HeaderHutReward from '@/components/partials/HeaderHutReward.vue'
import NavCategory from '../components/partials/NavCategory.vue'
import Cart from '../components/partials/Cart.vue'

export default {
  mounted() {
    let body = document.body

    body.classList.add('mainpage')
  },
  components: {
    NavCategory,
    Cart,
    HeaderHutReward
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/Main.vue